const downloadAppRedirect = {
    title: 'Redirecting to app download...',
    backBtn: 'Back to catalog',
};

export default downloadAppRedirect;
